/* eslint-disable jsx-a11y/media-has-caption */
import { FC, useRef, useState } from 'react';
import cn from 'classnames';

import { cleanBuilderStringInput, getBuilderString } from '@/shared/text';

import { Control } from './Control';
import style from './Video.module.scss';

export interface Settings {
  autoPlay?: boolean;
  poster?: string;
  source: string;
  mobileSource?: string;
}

export interface Props extends Settings {
  className?: string;
  locale: string;
}

export const Video: FC<Props> = ({
  className,
  poster,
  source,
  mobileSource,
  locale,
  autoPlay,
}) => {
  const [isVideoPlaying, setVideoPlaying] = useState(autoPlay ?? false);
  const videoPlayer = useRef<HTMLVideoElement>(null);
  const mobileVideoPlayer = useRef<HTMLVideoElement>(null);
  const toggleVideo = () => {
    setVideoPlaying(!isVideoPlaying);
    if (!isVideoPlaying) {
      videoPlayer.current?.play();
      if (mobileSource) {
        mobileVideoPlayer.current?.play();
      }
      return;
    }

    videoPlayer.current?.pause();
    if (mobileSource) {
      mobileVideoPlayer.current?.pause();
    }
  };

  return (
    <div data-testid="video" className={cn(className, style.container)}>
      <video
        className={cn({
          [style.video]: getBuilderString(mobileSource, locale),
        })}
        ref={videoPlayer}
        muted={autoPlay}
        autoPlay={autoPlay}
        loop
        playsInline
        poster={cleanBuilderStringInput(getBuilderString(poster, locale), true)}
        onClick={toggleVideo}
      >
        <source
          src={cleanBuilderStringInput(getBuilderString(source, locale), true)}
          type="video/mp4"
        />
      </video>
      {getBuilderString(mobileSource, locale) && (
        <video
          className={style.mobileVideo}
          ref={mobileVideoPlayer}
          muted
          autoPlay={autoPlay}
          loop
          playsInline
          poster={cleanBuilderStringInput(
            getBuilderString(poster, locale),
            true
          )}
          onClick={toggleVideo}
        >
          <source
            src={cleanBuilderStringInput(
              getBuilderString(mobileSource, locale),
              true
            )}
            type="video/mp4"
          />
        </video>
      )}
      <Control
        autoPlay={autoPlay}
        isPlaying={isVideoPlaying}
        toggleVideo={toggleVideo}
      />
    </div>
  );
};
